var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67738 12.0834C7.93756 12.5788 8.45705 12.9167 9.05547 12.9167H10.8333C11.7537 12.9167 12.4999 12.1705 12.4999 11.2501C12.4999 10.3296 11.7537 9.58339 10.8333 9.58339H9.16659C8.24611 9.58339 7.49992 8.8372 7.49992 7.91672C7.49992 6.99625 8.24611 6.25005 9.16659 6.25005H10.9444C11.5428 6.25005 12.0623 6.58797 12.3225 7.08339M9.99992 5.00005V6.25005M9.99992 12.9167V14.1667M16.6666 10.0001C16.6666 14.0904 12.205 17.0654 10.5816 18.0125C10.3971 18.1201 10.3048 18.1739 10.1747 18.2018C10.0736 18.2235 9.92622 18.2235 9.82519 18.2018C9.695 18.1739 9.60275 18.1201 9.41826 18.0125C7.79489 17.0654 3.33325 14.0904 3.33325 10.0001V6.01472C3.33325 5.34846 3.33325 5.01533 3.44222 4.72898C3.53848 4.47601 3.6949 4.25029 3.89797 4.07133C4.12783 3.86875 4.43975 3.75178 5.06359 3.51785L9.53175 1.84228C9.705 1.77732 9.79162 1.74483 9.88074 1.73196C9.95978 1.72053 10.0401 1.72053 10.1191 1.73196C10.2082 1.74483 10.2948 1.77732 10.4681 1.84228L14.9362 3.51785C15.5601 3.75178 15.872 3.86875 16.1019 4.07133C16.3049 4.25029 16.4614 4.47601 16.5576 4.72898C16.6666 5.01533 16.6666 5.34846 16.6666 6.01472V10.0001Z",
    stroke: "#667085",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDollar);
export default __webpack_public_path__ + "f77b465ff2493ec264a136fa91a0899a.svg";
export { ForwardRef as ReactComponent };